import type { BlogPost } from '../types'

export const DLACZEGO_BEZ_REJESTRACJI_EMAIL: BlogPost = {
  slug: 'dlaczego-bez-rejestracji-email',
  lang: 'pl',
  topicId: 'warum-keine-email-registrierung',
  title: 'Dlaczego Roofora rezygnuje z e-maila',
  metaDescription:
    'W Roofora rejestrujesz się tylko nazwą użytkownika i hasłem - bez adresu e-mail, bez numeru ' +
    'telefonu. Dlaczego tak to zbudowaliśmy.',
  keywords: [
    'oferty fotowoltaiczne bez e-maila',
    'portal dla rzemieślników bez rejestracji e-mail',
    'zbieranie ofert PV anonimowo',
    'oferty solarne bez lawiny telefonów',
    'ochrona danych zapytanie solarne',
  ],
  publishedAt: '2026-07-09',
  excerpt:
    'Do konta w Roofora potrzebujesz tylko nazwy użytkownika i hasła - żadnego adresu e-mail. To ' +
    'nie przypadek, lecz sedno naszej obietnicy w zakresie ochrony danych.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Kto choć raz pytał o ofertę na instalację solarną, zna prawdopodobnie ten schemat: podajesz ' +
        'swój e-mail i numer telefonu w formularzu - i w ciągu kilku dni telefon dzwoni co chwilę. ' +
        'Adres e-mail wędruje dalej do partnerów sprzedażowych, trafia do newsletterów, których ' +
        'nigdy nie subskrybowałeś, i w końcu nie wiadomo już, który z dziesięciu dzwoniących ' +
        'faktycznie złożył pierwotnie zapytaną ofertę. Dokładnie ten problem chcieliśmy w Roofora ' +
        'rozwiązać u samych korzeni - a korzeniem jest sam adres e-mail.',
    },
    {
      type: 'heading',
      text: 'Adres e-mail to już kanał kontaktu',
    },
    {
      type: 'paragraph',
      text:
        'Większość portali solarnych i dla rzemieślników wymaga e-maila i numeru telefonu już przy ' +
        'zakładaniu konta - na długo, zanim jakakolwiek firma rzemieślnicza złoży konkretną ofertę. ' +
        'Od tego momentu adres znajduje się w bazie danych, do której dostęp może mieć kilku ' +
        'partnerów sprzedażowych. Czy i jak często zostanie wykorzystany do kontaktu, zwykle ' +
        'wymyka się kontroli osoby pytającej. Podstawowym problemem nie jest więc "zbyt wiele ' +
        'telefonów", lecz to, że dane kontaktowe są przekazywane, zanim w ogóle podjęto świadomą ' +
        'decyzję, komu się zaufa.',
    },
    {
      type: 'heading',
      text: 'Jak naprawdę wygląda rejestracja w Roofora',
    },
    {
      type: 'paragraph',
      text:
        'Do konta klienta w Roofora potrzebujesz dokładnie dwóch rzeczy: nazwy użytkownika i hasła. ' +
        'To wszystko. Żadnego adresu e-mail, żadnego numeru telefonu, żadnego adresu ' +
        'korespondencyjnego. W naszym formularzu rejestracji po prostu nie ma na to pola - nie ' +
        'możesz więc tych danych ani podać, ani przypadkowo ujawnić. Możesz od razu złożyć ' +
        'zapytanie o instalację solarną, porównywać oferty firm rzemieślniczych i przejść cały ' +
        'proces pośrednictwa anonimowo, bez ujawniania, kim jesteś i jak się z Tobą skontaktować.',
    },
    {
      type: 'heading',
      text: 'A co z "zapomniałem hasła"?',
    },
    {
      type: 'paragraph',
      text:
        'Oczywisty zarzut: bez adresu e-mail zwykle nie ma też sposobu na zresetowanie zapomnianego ' +
        'hasła. Dlatego przy rejestracji otrzymujesz jednorazowy kod odzyskiwania, który możesz ' +
        'sobie zapisać - podobnie jak recovery key znany z menedżerów haseł. Dzięki niemu możesz ' +
        'odzyskać konto nawet bez zapisanego adresu e-mail. To świadomy kompromis: użytkownik sam ' +
        'odpowiada za ten kod, za to żadna informacja kontaktowa nie opuszcza naszej bazy danych ' +
        'bez pytania.',
    },
    {
      type: 'heading',
      text: 'Kiedy w ogóle potrzebny jest mój e-mail?',
    },
    {
      type: 'paragraph',
      text:
        'Dopiero wtedy, gdy sam tego aktywnie zechcesz - i tylko dla dokładnie jednej wybranej firmy ' +
        'rzemieślniczej. Jeśli firma po zapoznaniu się z Twoim (nadal anonimowym) zapytaniem i ' +
        'swoją ofertą chce nawiązać kontakt, sam indywidualnie decydujesz, czy dopuszczasz tę firmę. ' +
        'Dopiero po tej zgodzie podajesz adres e-mail lub numer telefonu dla dokładnie tego jednego ' +
        'kontaktu. Żadnej zbiorowej zgody, żadnego automatycznego przekazywania kolejnym firmom.',
    },
    {
      type: 'heading',
      text: 'Efekt: cisza w skrzynce, dopóki sam nie zdecydujesz inaczej',
    },
    {
      type: 'list',
      items: [
        'Brak spamu w skrzynce po pierwszym zapytaniu, bo w tym momencie żaden adres e-mail jeszcze nie istnieje',
        'Brak telefonów od handlowców, bo nikt nie zna Twojego numeru, dopóki go nie udostępnisz konkretnej firmie',
        'Pełna kontrola: decydujesz osobno dla każdej firmy rzemieślniczej, a nie zbiorowo dla wszystkich na platformie',
        'Porównywanie ofert wciąż bez ograniczeń - anonimowość nie kosztuje Cię żadnej funkcji',
      ],
    },
    {
      type: 'paragraph',
      text:
        'To różnica między "ochroną danych jako punktem w polityce prywatności" a "ochroną danych ' +
        'jako domyślnym ustawieniem w kodzie": jeśli pole w ogóle nie istnieje, nie da się go też ' +
        'nadużyć. Jeśli chcesz porównywać oferty instalacji solarnych bez późniejszego zalewu ' +
        'telefonów od handlowców, wypróbuj Roofora - rejestracja trwa mniej niż minutę, a my nawet ' +
        'nie pytamy Cię o adres e-mail.',
    },
  ],
  relatedLinks: [
    { label: 'Złóż zapytanie fotowoltaiczne', href: '/zlozyc-zapytanie-fotowoltaiczne' },
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
  ],
}
